/**
 * JS propio del proyecto (Digital Takeout), centralizado en este módulo por defecto (ver DEC-007).
 */

/**
 * Fuerza el header a mostrar siempre el menú en formato hamburguesa (drawer),
 * en cualquier tamaño de pantalla o dispositivo. Revierte cualquier cambio
 * posterior del atributo `data-menu-style` que haga el JS del tema base
 * (`@theme/utilities`), que por defecto alterna entre 'menu' y 'drawer'
 * según el dispositivo o el espacio disponible.
 */
function forceHeaderDrawerMenuStyle() {
  const header = document.querySelector('#header-component');
  if (!header) return;

  if (header.dataset.menuStyle !== 'drawer') {
    header.dataset.menuStyle = 'drawer';
  }

  new MutationObserver(() => {
    if (header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
}

document.addEventListener('DOMContentLoaded', forceHeaderDrawerMenuStyle);

const WELCOME_POPUP_SEEN_KEY = 'dt-welcome-popup-seen';

/**
 * Muestra el popup de bienvenida (`sections/dt-welcome-popup.liquid`) una vez por
 * sesión, tras `data-delay` segundos. En el Editor de temas lo muestra sin retardo
 * y sin consultar la sesión, para poder editarlo.
 * @param {ParentNode} root
 */
function initWelcomePopup(root = document) {
  const dialog = root.querySelector('[data-dt-welcome-popup]');
  if (!(dialog instanceof HTMLDialogElement) || dialog.dataset.dtInitialized) return;
  dialog.dataset.dtInitialized = 'true';

  const isDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  const wasSeen = () => {
    try {
      return sessionStorage.getItem(WELCOME_POPUP_SEEN_KEY) === 'true';
    } catch {
      return false;
    }
  };

  const markSeen = () => {
    try {
      sessionStorage.setItem(WELCOME_POPUP_SEEN_KEY, 'true');
    } catch {
      // sessionStorage no disponible: el popup puede reaparecer al navegar.
    }
  };

  dialog.querySelector('[data-dt-welcome-popup-close]')?.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (!isDesignMode) markSeen();
  });

  if (!isDesignMode && wasSeen()) return;

  const delay = isDesignMode ? 0 : Number(dialog.dataset.delay) || 0;
  setTimeout(() => {
    if (dialog.isConnected && !dialog.open) dialog.showModal();
  }, delay * 1000);
}

document.addEventListener('DOMContentLoaded', () => initWelcomePopup());
document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initWelcomePopup(event.target);
});
